import {BackendApi} from '@/services/backend_api'

export default {
  getByYear (year) {
    return BackendApi.getClient().get(`quiz-periods/?search=${year}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  post (quizPeriod) {
    return BackendApi.getClient().post('quiz-periods/', quizPeriod)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  put (quizPeriod) {
    return BackendApi.getClient().put(`quiz-periods/${quizPeriod.id}`, quizPeriod)
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/quiz_period.js